import React, { useEffect, useState } from 'react';
import './HomeComponent.css';
import ModalComponent from '../Modal/ModalComponent';
import { HeaderWithoutLogin } from '../Header/HeaderComponent';

const HomeComponent = () => {
  const [openModal, setOpenModal] = useState(false);
  const [isLive, setIsLive] = useState(false);

  const codigoPromomatts = 'CLA24DI00382';

  const openModalHandler = () => {
    setOpenModal(true);
    //window.location.href = "https://scienncetvnovonordisk.com/medico-innovador";
  };

  const closeModalHandler = () => {
    setOpenModal(false);
  };

  const calculateTimeLeft = () => {
    // Define la fecha y hora objetivo en la hora local de Guatemala (UTC-6)
    const targetDate = new Date("2024-10-05T09:00:00-05:00"); // 9:00 AM hora de Perú (UTC-5)

    // Obtiene la fecha y hora actual
    const now = new Date();

    // Calcula la diferencia en milisegundos
    const difference = targetDate - now;
    let timeLeft = {
      days: 0,
      hours:  0,
      minutes: 0,
      seconds: 0,
    };

    if (difference > 0) {
      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);

      timeLeft = {
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds,
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);


    const { days, hours, minutes, seconds } = timeLeft;
    if (days === 0 && hours === 0 && minutes === 0 && seconds === 0) {
      setIsLive(true);
    } else {
      setIsLive(false);
    }

    return () => clearInterval(timer);
  }, []);

  const timerComponents = [];

  Object.keys(timeLeft).forEach((interval, index) => {
    timerComponents.push(
      <span key={index} className="text-white text-5xl">
        {timeLeft[interval] < 10 ? `0${timeLeft[interval]}` : timeLeft[interval]}
      </span>
    );
  });

  return (
    <>
      <div className="home-component flex flex-col min-h-screen">
        {/* pc */}
        <HeaderWithoutLogin />
        <div className="flex-grow flex">
          <div className="hidden md:flex lg:flex xl:flex w-1/3 flex flex-col items-center justify-center p-4 mt-5 mx-5 sm">
            <img src="./logo_medicoinnovador_blanco.png" alt="Imagen" className="max-w-full max-h-full" />
            <hr className="bg-gray-400 w-full border-none mt-4 opacity-100" style={{ padding: '1px' }} />
            <p className="mt-1 text-white text-center">Comienza en...</p>
            <div className="flex flex-col items-center">
              <div className="text-white text-5xl flex justify-center items-baseline space-x-1">
                <span>{timeLeft.days < 10 ? `0${timeLeft.days}` : timeLeft.days}</span>
                <span>,</span>
                <span>{timeLeft.hours < 10 ? `0${timeLeft.hours}` : timeLeft.hours}</span>
                <span>:</span>
                <span>{timeLeft.minutes < 10 ? `0${timeLeft.minutes}` : timeLeft.minutes}</span>
                <span>:</span>
                <span>{timeLeft.seconds < 10 ? `0${timeLeft.seconds}` : timeLeft.seconds}</span>
              </div>
              <div className="flex justify-center space-x-6 mt-2 text-yellow-400 text-lg font-semibold">
                <span className='fw-bold'>DÍAS</span>
                <span className='fw-bold'>HORAS</span>
                <span className='fw-bold'>MIN.</span>
                <span className='fw-bold'>SEG.</span>
              </div>
            </div>
  
            <hr className="bg-gray-400 w-full border-none mt-4 opacity-100" style={{ padding: '1px' }} />
  
            {/* button register */}
            <button
              className="p-2 rounded-full fw-bold fs-5 w-full bg-aqua-light text-white"
              onClick={() => openModalHandler()}
            >
              {'Ingrese aquí'}
            </button>
  
            <h3 className="mt-3 fs-6 text-white text-center">Más contenido médico en</h3>
            <div className="grid grid-cols-1 gap-4 mt-2 w-full">
              <div className="flex items-center justify-center w-full">
                <img
                  src="./logo_scienncetv_blanco.png"
                  alt="scienncetv"
                  className="w-60 h-auto rounded-lg"
                />
              </div>
              <div className="flex flex-col items-center justify-center w-full hidden">
                <span className="text-center text-white text-xs ">Avalado.</span>
                <img
                  src="./logos_asociaciones.png"
                  alt="scienncetv"
                  className="w-60 h-full rounded-lg mt-2"
                />
              </div>
            </div>
            <p className="mt-5 text-xs text-white text-center">Para una mejor experiencia, conéctese desde su computadora.</p>
          </div>
  
          {/* movil responsive */}
          <div className="flex md:hidden lg:hidden xl:hidden w-full flex flex-col items-center justify-center mt-5 p-3 md:w-1/3">
            <img src="./logo_medicoinnovador_blanco.png" alt="Imagen" className="max-w-full max-h-full" />
            <hr className="bg-gray-400 w-full border-none mt-4 opacity-100" style={{ padding: '1px' }} />
            <p className="mt-1 text-white text-center">Comienza en...</p>
            <div className="flex flex-col items-center">
              <div className="text-white text-5xl flex justify-center items-baseline space-x-1">
                <span>{timeLeft.days < 10 ? `0${timeLeft.days}` : timeLeft.days}</span>
                <span>,</span>
                <span>{timeLeft.hours < 10 ? `0${timeLeft.hours}` : timeLeft.hours}</span>
                <span>:</span>
                <span>{timeLeft.minutes < 10 ? `0${timeLeft.minutes}` : timeLeft.minutes}</span>
                <span>:</span>
                <span>{timeLeft.seconds < 10 ? `0${timeLeft.seconds}` : timeLeft.seconds}</span>
              </div>
              <div className="flex justify-center space-x-6 mt-2 text-yellow-400 text-lg font-semibold">
                <span className='fw-bold'>DÍAS</span>
                <span className='fw-bold'>HORAS</span>
                <span className='fw-bold'>MIN.</span>
                <span className='fw-bold'>SEG.</span>
              </div>
            </div>
  
            <hr className="bg-gray-400 w-full border-none mt-4 opacity-100" style={{ padding: '1px' }} />
  
            {/* button register */}
            <button
              className="p-2 rounded-full fw-bold fs-5 w-full bg-aqua-light text-white"
              onClick={() => openModalHandler()}
            >
              {'Ingrese aquí'}
            </button>
  
            <h3 className="mt-3 fs-6 text-white text-center">Más contenido médico en</h3>
            <div className="grid grid-cols-1 gap-4 mt-2 w-full">
              <div className="flex items-center justify-center w-full">
                <img
                  src="./logo_scienncetv_blanco.png"
                  alt="scienncetv"
                  className="w-60 h-auto rounded-lg"
                />
              </div>
              <div className="flex flex-col items-center justify-center w-full hidden">
                <span className="text-center text-white text-xs ">Avalado.</span>
                <img
                  src="./logos_asociaciones.png"
                  alt="scienncetv"
                  className="w-60 h-full rounded-lg mt-2"
                />
              </div>
            </div>
            <p className="mt-5 text-xs text-white text-center">Para una mejor experiencia, conéctese desde su computadora.</p>
          </div>
        </div>
  
        {/* modal login o register */}
        <ModalComponent showModal={openModal} closeModal={closeModalHandler} />
  
        {/* footer siempre abajo */}
        <footer className="bg-[#00166f] text-white text-xs py-2 px-4 flex justify-between items-center mt-auto w-full">
          <div className="max-w-screen-lg mx-auto flex flex-col md:flex-row items-center justify-between w-full">
            <p className="leading-tight md:mr-4 text-justify mt-2">
              Novo Nordisk® es una marca registrada propiedad de Novo Nordisk A/S. Material revisado y aprobado por la Dirección de Asuntos Médicos y Regulatorios de Novo Nordisk® Para uso exclusivo del profesional de la salud y en Guatemala es para uso exclusivo del profesional médico. Si tiene alguna solicitud de información médica escríbanos a medicalinfo_clat@novonordisk.com {codigoPromomatts}
            </p>
            <div className="mt-2 md:mt-0">
              <img src="./logo-novo-white.png" alt="Novo Nordisk logo" className="w-40 h-38 md:h-10" />
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}  

export default HomeComponent;